import { c as _c } from "react/compiler-runtime";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { toggleItemSelection } from "@utils/array-utils";
import { selectedRowIdsSelector } from "@store/table/table-selector";
import { setInitialFetchingItems } from "@store/table/table-slice";
import { InfoIcon, SelectionIcon } from "@flat-ui";
import { useMembersUtils } from "@hooks/use-member-utils";

/** Hook to get the menu options for group members in mobile view */
export function useGroupMembersMenuOptionsMobile() {
  const $ = _c(8);
  const dispatch = useAppDispatch();
  const {
    openProfilePage
  } = useMembersUtils();
  const selectedRowIds = useAppSelector(selectedRowIdsSelector);
  let t0;
  if ($[0] !== dispatch || $[1] !== selectedRowIds) {
    t0 = {
      label: "Select member",
      Icon: SelectionIcon,
      onSelect: member => {
        const newSelectedRowIds = toggleItemSelection(selectedRowIds, member.identity);
        dispatch(setInitialFetchingItems(newSelectedRowIds));
      },
      shouldShowDividerAfter: true
    };
    $[0] = dispatch;
    $[1] = selectedRowIds;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== openProfilePage) {
    t1 = {
      label: "Profile",
      Icon: InfoIcon,
      onSelect: member_0 => {
        openProfilePage({
          member: member_0,
          source: "user more info menu mobile"
        });
      }
    };
    $[3] = openProfilePage;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = [t0, t1];
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const menuOptions = t2;
  return menuOptions;
}